import {
  CustomerMetrics,
  CustomerMetricsData,
  CustomerMetricsRepository,
  DatabaseService,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getCustomerMetricsRepository(
  databaseService: DatabaseService,
): CustomerMetricsRepository {
  return getGenericRepository<CustomerMetrics, CustomerMetricsData>(
    () => DatabaseCollection.CUSTOMER_METRICS,
    databaseService,
  );
}
